export default {
      id: "loading_icon-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#loading_icon",
      toString: function () {
        return this.url;
      }
    }